import React, { useState, useEffect } from 'react';
import { firebaseConfig } from './firebaseConfig';
import { initializeApp } from 'firebase/app';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import SignUpComponent from './Auth/SignUpComponent';
import SignInComponent from './Auth/SignInComponent';
import Dashboard from './Dashboard';
import ProjectPage from './ProjectPage';
import './globalStyles.css';
import BetaIndicator from './Components/BetaIndicator'; // Import the BetaIndicator component


const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

function App() {
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, user => {
      setCurrentUser(user);
    });

    return () => unsubscribe();
  }, []);

  return (
    <Router>
      <div className="App">
       
          <Routes>
            {currentUser ? (
              <>
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/projectPage/:projectId" element={<ProjectPage />} />
                <Route path="*" element={<Navigate to="/dashboard" replace />} />
              </>
            ) : (
              <>
                <Route path="/signIn" element={<SignInComponent />} />
                <Route path="/signup" element={<SignUpComponent />} />
                <Route path="*" element={<Navigate to="/signIn" replace />} />
              </>
            )}
          </Routes>
          <BetaIndicator /> 
      </div>
    </Router>
  );
}

export default App;
